import { placeholderInSelection, deleteAndSetMarks } from '..';
export default function makeOnPaste(_ref) {
  var store = _ref.store;
  return {
    onPaste: function onPaste(event, editor, next) {
      var placeholder = placeholderInSelection(editor, store);

      if (placeholder) {
        deleteAndSetMarks(editor, placeholder.key);
      }

      return next();
    }
  };
}